/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
export const shortenAddress = (
  address: string,
  prefixChars: number = 6,
  suffixChars: number = 4
) => {
  const length = address.length
  const prefix = address.substring(0, prefixChars)
  const suffix = address.substring(length - suffixChars, length)

  return `${prefix}...${suffix}`
}
